if (!customElements.get('component-swiper')) {
  customElements.define(
    'component-swiper',
    class ComponentSwiper extends HTMLElement {
      constructor() {
        super();
        
        this.settings = JSON.parse(this.querySelector('script[type="application/json"]')?.innerHTML || '{}');
        this.swiperId = this.querySelector('.swiper')?.id;
        
        if (!this.swiperId) return;

        this.swiper = new Swiper(`#${this.swiperId}`, this.settings);
        
      }
      
    }
  )
}

